/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowFatLineRight(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M132.93848,231.39062A8,8,0,0,1,128,224V184H72a8.00039,8.00039,0,0,1-8-8V80a8.00039,8.00039,0,0,1,8-8h56V32a8.00065,8.00065,0,0,1,13.65723-5.65723l96,96a8.003,8.003,0,0,1,0,11.31446l-96,96A8.002,8.002,0,0,1,132.93848,231.39062ZM48,176V80a8,8,0,0,0-16,0v96a8,8,0,0,0,16,0Z" />
    </Svg>
  );
}

export default ArrowFatLineRight;
